import { call, put, takeEvery } from 'redux-saga/effects';
import { DeleteTargetedCatalogSection, targetedCatalogActionCreators, TargetedCatalogActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { deleteSection } from '../targetedCatalogApi';
import { ITargetedCatalogSectionBase } from '../targetedCatalogInterfaces';

function* deleteTargetedCatalogSectionSaga(action: DeleteTargetedCatalogSection) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<ITargetedCatalogSectionBase[]> = yield call(
    deleteSection,
    action.payload.sectionId
  );

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(targetedCatalogActionCreators.removeSection(action.payload.sectionId));
    yield put(targetedCatalogActionCreators.setSectionMins(response.value));
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteTargetedCatalogSection() {
  yield takeEvery(TargetedCatalogActionKeys.DELETE_TARGETED_CATALOG_SECTION, deleteTargetedCatalogSectionSaga);
}
